import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {http_auth} from "@utils"
import {toast} from "react-toastify"
import * as auth from "../Auth"
import {REFRESH_TOKEN} from "../../../utility/Utils"

export const getNotifyList = createAsyncThunk('notify/getNotifyList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/notify/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getNotifyByObjectId = createAsyncThunk('notify/getNotifyByObjectId', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/notify/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getSmsByFounder = createAsyncThunk('notify/getSmsByFounder', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/found/give-founder-sms', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const giveSmsByOwner = createAsyncThunk('notify/giveSmsByOwner', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/registration/v1/found/give-owner-verify-sms', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const notifySlice = createSlice({
    name: 'notify',
    initialState: {
        notifyList: [],
        notify: null,

        count_item: 0,
        total_count: 0,
        current_page: 0,
        notifySize: 0,
        isLoading: false,
        isSuccess: false
    },
    reducers: {},
    extraReducers: {
        [getNotifyList.fulfilled]: (state, actions) => {
            state.notifyList = actions.payload?.data
            state.current_page = actions.payload?.page
            state.count_item = actions.payload?.count
            state.notifySize = actions.payload?.total_count
            state.total_count = actions.payload?.total_count
            state.isLoading = false
        },
        [getNotifyList.pending]: (state) => {
            state.isLoading = true
        },
        [getNotifyList.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        [getNotifyByObjectId.fulfilled]: (state, actions) => {
            if (actions.payload?.data?.length !== 0) {
                state.notify = actions.payload?.data[actions.payload?.data?.length - 1]
                if (actions.payload?.data[actions.payload?.data?.length - 1]?.status !== "SENT_SMS") {
                    toast.info(actions?.payload?.data[actions.payload?.data?.length - 1]?.content)
                }
            } else {
                toast.warning("Ariza bo`yicha eslatma mavjud emas")
            }
        },
        [getNotifyByObjectId.rejected]: (state, action) => {
            toast.error(action.payload)
        },

        [getSmsByFounder.fulfilled]: (state, actions) => {
            state.isSuccess = true
            toast.success(actions.payload?.data)
        },
        [getSmsByFounder.rejected]: (state, action) => {
            state.isSuccess = false
            toast.error(action.payload)
        },

        [giveSmsByOwner.fulfilled]: (state, actions) => {
            state.isSuccess = true
            toast.success(actions.payload?.data)
        },
        [giveSmsByOwner.rejected]: (state, action) => {
            state.isSuccess = false
            toast.error(action.payload)
        }
    }
})

export const {} = notifySlice.actions
export default notifySlice.reducer
